import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";
import {
  Table,
  Tooltip,
  Tag,
  Input,
  Button,
  Space,
  message,
  Drawer,
  Modal,
  Statistic,
  Row,
  Col,
  Typography,
  List,
  Descriptions,
  Select,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./styles.scss";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import moment from "moment";
import { Column } from "@ant-design/plots";
import MainPie from "../../analytics/MainPie";

import LineTime from "../../analytics/LineTime";
import ColumnTime from "../../analytics/ColumnTime";
import ColumnGroupTime from "../../analytics/ColumnGroupTime";
import ColumnStackedTime from "../../analytics/ColumnStackedTime";

import { numberWithCommas } from "../../../utils/helpers";

import { fixbrockenpackages } from "../../../Redux/actions/packageActions";
import {
  getProductInventoryLogwithDateRange,
  getProductInventoryLogLastestFromDate,
} from "../../../Redux/actions/inventoryActions";
import { getProduct } from "../../../Redux/actions/productActions";

import WastedmenuExport from "../exports/wastedmenuExport";

const { Title } = Typography;

const Index = ({
  prod_inventory,
  product_ID,
  datePickerValue,
  exchagerate,
  onValueComputed,
  currentLocationDetails,
}) => {
  const dispatch = useDispatch();

  const { crudData, crudDataCount, locations, user, currentProps } =
    useSelector(
      (state) => ({
        user: state.auth.user,
        crudData: state.analytics.data,
        crudDataCount: state.analytics.dataCount,
        locations: state.locations.locations,
        currentProps: state.analytics.currentProps,
      }),
      shallowEqual
    );

  const { Option } = Select;

  const [categoryFilter, setCategoryFilter] = useState({});
  const [selectedCategory, setSelectedCategory] = useState({});

  const [currentProduct, setCurrentProduct] = useState(null);
  const [latestCost, setLatestCost] = useState(0);

  const [currentQTY, setCurrentQTY] = useState(0);
  const [currentCost, setCurrentCost] = useState(0);
  const [currentValue, setCurrentValue] = useState(0);

  const [loading, setLoading] = useState(false);

  const [inventoryData, setinventoryData] = useState([]);

  useEffect(() => {
    if (product_ID) {
      getthisProduct(product_ID);
    }
  }, [product_ID]);

  const getthisProduct = async (prodid) => {
    var prod = await dispatch(getProduct(prodid));
    if (prod) {
      setCurrentProduct(prod);
    } else {
    }
  };

  useEffect(() => {
    if (currentProduct) {
      console.log("currentProduct", currentProduct);
      getInventoryLogs();
      var curr_cost = 0;

      if (currentProduct.regionalization == "local") {
        curr_cost = parseFloat(currentProduct.cost_peso);
      } else {
        curr_cost =
          parseFloat(currentProduct.cost_rmb) * parseFloat(exchagerate);
      }
      setCurrentCost(curr_cost);
    }
  }, [currentProduct]);

  useEffect(() => {
    if (currentProduct) {
      getInventoryLogs();
    }
  }, [datePickerValue]);

  const getInventoryLogs = async () => {
    var inventory_logs = await dispatch(
      getProductInventoryLogLastestFromDate(prod_inventory.id, datePickerValue)
    );
    setinventoryData(inventory_logs);

    if (inventory_logs.length > 0) {
      setCurrentQTY(inventory_logs[0].quantity);
    } else {
      setCurrentQTY(0);
    }
  };

  useEffect(() => {
    if (currentProduct && currentQTY) {
      computeValue();
    }
  }, [currentQTY]);

  const computeValue = () => {
    var curr_value = 0;
    if (currentQTY && currentCost) {
      curr_value = parseFloat(currentQTY) * parseFloat(currentCost);
    }

    if (
      curr_value &&
      currentProduct.name &&
      currentQTY > 0 &&
      currentProduct.menu_item != true
    ) {
      setCurrentValue(curr_value);

      var computed_val = {
        value: curr_value,
        total_cost: curr_value.toFixed(2),
        product: currentProduct,
        cost: currentCost.toFixed(2),
        name: currentProduct.name,
        unit: currentProduct.unit,

        quantity: parseFloat(currentQTY).toFixed(2),
        address: currentLocationDetails.address,
      };

      onValueComputed(computed_val);
    }
  };

  if (currentProduct) {
    return (
      <div className="inventroy_item_container">
        <div className="description">
          {currentProduct.name}
          <div>
            qty: {currentQTY} {currentProduct?.unit}
          </div>
          <div>latest unit cost: {currentCost} </div>

          <div>value: PHP {currentValue}</div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default Index;
